import React from "react";
import "./starloader.scss";

const StarLoader = () => {
  return (
    <div className="star-loader">
      <div className="loader-content">
        <div className="rotating-ring"></div>
        <div className="center-star">🌟</div>

        {/* Twinkling stars */}
        <div className="twinkle star1">✨</div>
        <div className="twinkle star2">✨</div>
        <div className="twinkle star3">✨</div>
        <div className="twinkle star4">✨</div>
        <div className="twinkle star5">✨</div>

        <p className="loading-text">Loading...</p>
      </div>
    </div>
  );
};

export default StarLoader;
